import React, { Component } from 'react'
import Select, { Creatable, Async } from 'react-select';
import {SelectField, AsyncSelectField} from '../../Utils/renderField/renderField.js'
import { Field } from 'redux-form';
import { SingleDatePicker } from 'react-dates'
import classNames from 'classnames';
import { api } from 'api';
import { BODEGAS_TRANSICION_ID } from '../../../../utility/constants';


export default class ToolbarReporteMateriaPrima extends Component {

    getProductos = (search) => {
        let params = {}
        if(search){
            params.search = search;
        }
        if(this.props.empresa){
            params.empresa = this.props.empresa;
        }
        return api.get("productos", params).
        then((data) => {
            if (data){
                return data.results;
            }
            return [];
        }).catch(() => {
            return [];
        });
    };

    getBodegas = (search) => {
        return api.get("bodega", { search }).
        then((data) => {
            if (data) {
                let bodegas = [];
                data.results.forEach(item => {
                    if(item.id != this.props.bodega){
                        bodegas.push(item);
                    }
                });
                return bodegas;
            };
            return [];
        }).catch(() => {
            return [];
        });
    };

    handleCheckedBodegaTransicion = (value) => {
        this.props.setBodegaTransicionFilter(value, this.props.idBodega);
    };

    handleCheckedVendible = (value) => {
        this.props.setVendibleFilter(value, this.props.idBodega);
    };

    handleCheckedFacturado = (value) => {
        this.props.setFacturadoFilter(value, this.props.idBodega);
    };

    render() {
        const { bodega, producto, facturado_filter, vendible_filter, bodega_transicion_filter } = this.props;
        const esBodegaVirtual = bodega && BODEGAS_TRANSICION_ID.includes(bodega.id)

        return (
            <div className="row col-12 p-0">
                <div className="row col-12 m-0 text-lg-left">
                    <div className={"col-lg-3 col-md-4 col-6 align-self-center"}>
                        <span className="t-azul-claro font-weight-bold">Bodega</span>
                        <Async
                            isClearable={true}
                            backspaceRemovesValue={false}
                            value={bodega}
                            isSearchable={true}
                            loadOptions={this.getBodegas}
                            getOptionValue={(option) => (option["id"])}
                            getOptionLabel={(option) => (option["nombre"])}
                            type="text"
                            onChange={(e) => this.props.changeBodega(e)}
                            multi={true}
                            autoload={false}
                            cache={false}
                            className={classNames('react-select-container ')}
                            defaultOptions={true}
                            placeholder="Seleccionar.."
                        />
                    </div>
                    <div className={"col-lg-3 col-md-4 col-6 align-self-center"}>
                        <span className="t-azul-claro font-weight-bold">Producto</span>
                        <Async
                            isClearable={true}
                            backspaceRemovesValue={false}
                            value={producto}
                            isSearchable={true}
                            loadOptions={this.getProductos}
                            getOptionValue={(option) => (option["id"])}
                            getOptionLabel={(option) => (option["nombre"])}
                            type="text"
                            onChange={(e) => this.props.changeProducto(e)}
                            multi={true}
                            autoload={false}
                            cache={false}
                            className={classNames('react-select-container ')}
                            defaultOptions={true}
                            placeholder="Seleccionar.."
                        />
                    </div>

                    {
                        (esBodegaVirtual) &&
                        <div className="col-lg-2 col-md-3 col-12">
                            <div>
                                <input
                                    type="radio"
                                    className="btn-check"
                                    name="opcionesBodegaTransicion1"
                                    id="opcion1"
                                    autoComplete="off"
                                    checked={bodega_transicion_filter === 0}
                                    onChange={() => this.handleCheckedBodegaTransicion(0)}
                                />
                                <label className="ml-1" htmlFor="opcion1">MP / Poducción</label>
                            </div>

                            <div>
                                <input
                                    type="radio"
                                    className="btn-check"
                                    name="opcionesBodegaTransicion2"
                                    id="opcion2"
                                    autoComplete="off"
                                    checked={bodega_transicion_filter === 10}
                                    onChange={() => this.handleCheckedBodegaTransicion(10)}
                                />
                                <label className="ml-1" htmlFor="opcion2">MP</label>
                            </div>

                            <div className="">
                                <input
                                    type="radio"
                                    className="btn-check"
                                    name="opcionesBodegaTransicion3"
                                    id="opcion3"
                                    autoComplete="off"
                                    checked={bodega_transicion_filter === 20}
                                    onChange={() => this.handleCheckedBodegaTransicion(20)}
                                />
                                <label className="ml-1" htmlFor="opcion3">Producción</label>
                            </div>
                        </div>
                    }
                    {
                        // (esBodegaVirtual) &&
                        <div className="col-lg-2 col-md-3 col-12">
                            <div>
                                <input
                                    type="radio"
                                    className="btn-check"
                                    name="opcionesVendible1111"
                                    id="opcion1111"
                                    autoComplete="off"
                                    checked={vendible_filter === 0}
                                    onChange={() => this.handleCheckedVendible(0)}
                                />
                                <label className="ml-1" htmlFor="opcion1111">Vendible / No Vendible</label>
                            </div>

                            <div>
                                <input
                                    type="radio"
                                    className="btn-check"
                                    name="opcionesVendible2222"
                                    id="opcion2222"
                                    autoComplete="off"
                                    checked={vendible_filter === 1}
                                    onChange={() => this.handleCheckedVendible(1)}
                                />
                                <label className="ml-1" htmlFor="opcion2222">No Vendible</label>
                            </div>

                            <div className="">
                                <input
                                    type="radio"
                                    className="btn-check"
                                    name="opcionesVendible3333"
                                    id="opcion3333"
                                    autoComplete="off"
                                    checked={vendible_filter === 2}
                                    onChange={() => this.handleCheckedVendible(2)}
                                />
                                <label className="ml-1" htmlFor="opcion3333">Vendible</label>
                            </div>
                        </div>
                    }

                    {
                        // (esBodegaVirtual) &&
                        <div className="col-lg-2 col-md-3 col-12">
                            <div>
                                <input
                                    type="radio"
                                    className="btn-check"
                                    name="opcionesFacturado11111"
                                    id="opcion11111"
                                    autoComplete="off"
                                    checked={facturado_filter === 0}
                                    onChange={() => this.handleCheckedFacturado(0)}
                                />
                                <label className="ml-1" htmlFor="opcion11111">Facturado / No Facturado</label>
                            </div>

                            <div>
                                <input
                                    type="radio"
                                    className="btn-check"
                                    name="opcionesFacturado22222"
                                    id="opcion22222"
                                    autoComplete="off"
                                    checked={facturado_filter === 1}
                                    onChange={() => this.handleCheckedFacturado(1)}
                                />
                                <label className="ml-1" htmlFor="opcion22222">No Facturado</label>
                            </div>

                            <div className="">
                                <input
                                    type="radio"
                                    className="btn-check"
                                    name="opcionesFacturado33333"
                                    id="opcion33333"
                                    autoComplete="off"
                                    checked={facturado_filter === 2}
                                    onChange={() => this.handleCheckedFacturado(2)}
                                />
                                <label className="ml-1" htmlFor="opcion33333">Facturado</label>
                            </div>
                        </div>
                    }
                </div>
            </div>
        )
    }
}